import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input } from "@angular/core";
import { IsNavigationExpandedCache } from "@webapp/navigation/services/is-navigation-expanded.cache";
import { ReflectionPanel } from "@webapp/reflections/models/reflection-panel.models";
import { ReflectionOverviewFilterName } from "@webapp/reflections/models/reflections.models";
import { COLLAPSE_PANEL_CONFIG_TOKEN, CollapsePanelConfig, CollapsePanelHeaderDirective } from "../collapse-panel-header.directive";

@Component({
  selector: "collapse-panel-header-compare",
  templateUrl: "./collapse-panel-header-compare.component.html",
  styleUrls: ["collapse-panel-header-compare.component.less"],
  providers: [{ provide: COLLAPSE_PANEL_CONFIG_TOKEN, useValue: { compareMode: true } }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollapsePanelHeaderCompareComponent extends CollapsePanelHeaderDirective {
  @Input() public currentCheckIn: ReflectionPanel;
  @Input() public previousCheckIn: ReflectionPanel;
  @Input() public filter: ReflectionOverviewFilterName;

  constructor(isNavExpanded: IsNavigationExpandedCache, cdr: ChangeDetectorRef, @Inject(COLLAPSE_PANEL_CONFIG_TOKEN) config: CollapsePanelConfig) {
    super(isNavExpanded, cdr, config);
  }
}
